<template>
  <v-layout>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
      <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog">{{ $t('edit') | cap }} {{ $tc('Intention', 1) }} : {{intentDialog.code}}</div>
          <v-spacer></v-spacer>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            flat
            class="white--text"
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="submitDialogUpdateIntent"
          >{{ $t('submit') }}</v-btn>
      </v-card-title>

      <v-tabs
          v-model="currentTab"
          left
          slider-color="secondary"
      >
          <v-tab
          v-for="tab of tabs"
          :key="tab.index"

          >
          <v-icon class="primary--text">{{tab.icone}}</v-icon>
          {{tab.name}}
          </v-tab>

          <v-tab-item :key="'tab_fiche'" >
            <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : ''">
              <v-layout>
                  <!-- infos lead -->
                  <v-flex xs12 md4 pr-2>
                    <v-card-text>
                        <p v-if="modeExpert">
                        <span class='body-1 font-italic'>{{$t('intentCode')}} :</span><br>
                        <span class='body-2 font-weight-bold'>{{intentDialog.code}}</span>
                        </p>
                        <p v-if="modeExpert">
                        <span class='body-1 font-italic'>chatbot ID :</span><br>
                        <span class='body-2 font-weight-bold'>{{intentDialog.botWorkspace}}</span>
                        </p>
                        <v-textarea 
                        label="Thème / Description" 
                        v-model="intentDialog.desc"
                        :error="wzErrors.has('intentDialog')"
                        :errors="wzErrors.collect('intentDialog')"
                        ></v-textarea>
                        <v-spacer></v-spacer>
                        <small>*{{ $t('required') }}</small>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs12 md8 pl-2>
                    <v-layout>
                        <!-- titre -->
                        <v-flex xs6>
                        <span align-left>{{ $t('intentExamples') + '*' }}</span>
                        </v-flex>
                        <!-- add exemple -->
                        <v-flex xs6 class="text-xs-right">
                        <div  class='btnIntentBot' @click="addExample()">
                            <v-btn small icon color="secondary" >
                            <v-icon>add</v-icon>
                            </v-btn>
                            <span class="pl-2">Ajouter un nouvel exemple</span>
                        </div>
                        </v-flex>
                    </v-layout>
                    <div style="overflow: auto; height: calc(100vh - 350px);">
                      <v-data-table
                        :items="samplesInt"
                        hide-actions
                        >
                        <template slot="items" slot-scope="props">
                          <td>
                          <v-edit-dialog
                              :cancel-text="$t('cancel')"
                              :save-text="$t('submit')"
                              :return-value.sync="samplesInt"
                              large
                              lazy
                          >
                              <div><code>{{ props.item.content }}</code></div>
                              <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                              <v-text-field
                              slot="input"
                              label="Modification"
                              v-model="props.item.content"
                              single-line
                              counter
                              autofocus
                              ></v-text-field>
                          </v-edit-dialog>
                          </td>
                          <td class="text-xs-right">
                          <v-btn icon flat @click.stop="deleteSampleIntent(props.item)">
                              <v-icon>delete</v-icon>
                          </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
              </v-layout>
            </v-card-text>
          </v-tab-item>
      </v-tabs>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="cancelDialog()">{{ $t('cancel') }}</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="submitDialogUpdateIntent"
        >{{ $t('submit') }}</v-btn>
      </v-card-actions>
   </v-card>

    <!-- Ajoute un exemple de question a l'INTENT -->
    <v-dialog
      v-model="showDialogAddQuestionIntent"
      persistent
      max-width="390"
    >
      <wz-new-question-intent
        :intentDialog="intentDialog"
        :modeExpert="modeExpert"
        :botWorkspace="botWorkspace"
        @closeDialog="closeDialogNewQuestionIntent"
        @addNewEx="addNewEx"
      ></wz-new-question-intent>
    </v-dialog>    

  </v-layout>
</template>



<script>

export default {
  props: {
    intentDialog: {
      type: Object,
      default: () => ({})
    },
    samplesInt: {
      type: Array,
      default: () => ([])
    },
    sampleOriginalName: {
      type: String,
      default: ''
    },
    activeIntents: {
      type: Number,
      default: 0
    },
    modeExpert: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showDialogAddQuestionIntent: false,
      listIntents: [],
      samples: [],
      tabs: [],
      currentTab: 0,
      loading: false
    }
  },

  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    cancelDialog () {
      this.showDialogAddQuestionIntent = false
      this.$emit('closeDialog')
    },
    addExample () {
      this.showDialogAddQuestionIntent = true
      console.log('addExemple', this.intentDialog)
      // this.$emit('addExampleIntent')
    },
    closeDialogNewQuestionIntent () {
      this.showDialogAddQuestionIntent = false
    },
    deleteSampleIntent (value) {
      console.log('deleteSampleIntent', value)
      // this.$emit('openDialogDeleteSampleIntent', value)
    },
    submitDialogUpdateIntent () {
      this.loading = true
      // this.showDialogUpdateIntent = false

      let dataToPost = new window.FormData()
      dataToPost.append('code', this.intentDialog.code)
      dataToPost.append('origin', this.sampleOriginalName)
      dataToPost.append('desc', this.intentDialog.desc)
      dataToPost.append('samples', JSON.stringify(this.samples))
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/edit_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      /* this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) */
      .then(response => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        this.$store.commit('_User/RELOAD_WATSON', {
          editWatson: Math.random()
        })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    addNewEx (data) {
      this.showDialogAddQuestionIntent = false
      if (data !== '') this.samplesInt.push(data)
    }
  },

  watch: {},

  filters: {
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .btnIntentBot {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzUpdateIntent.vue